import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { clearCreateCropAction, createCropAction, updateCropAction, clearUpdateCropAction, getAllCropsAction } from "../../store/actions";
import toast from "react-hot-toast";

export default function CropInformation({ onClose, cropId, onRefresh }) {
  const dispatch = useDispatch();
  const { successData, error, errorInfo } = useSelector((state) => state.createCropReducer);
  const { successData: getByCropData } = useSelector((state) => state.getByCropReducer);
  const { successData: updateSuccess, error: updateError, errorInfo: updateErrorInfo } = useSelector((state) => state.updateCropReducer);
  const [cropName, setCropName] = useState("");

  const handleSubmit = () => {
    if (cropName.trim() === "") {
      toast.error("Crop name is required");
      return;
    }
    if (cropId) {
      dispatch(updateCropAction({ endPoint: `crop/${cropId}`, name: cropName.trim() }));
      dispatch(getAllCropsAction());
    } else {
      dispatch(createCropAction({ name: cropName.trim() }));
      dispatch(getAllCropsAction());
    }
  };

  useEffect(() => {
    if (cropId && getByCropData?.data?.name) {
      setCropName(getByCropData.data.name || "");
    }
    // Clear input when switching to create mode
    if (!cropId) {
      setCropName("");
    }
  }, [cropId, getByCropData]);

  useEffect(() => {
    if (successData) {
      const message = successData?.message || "Crop created successfully";
      toast.success(message);
      dispatch(clearCreateCropAction());
      if (onRefresh) onRefresh();
      if (onClose) onClose();
    }

    if (error) {
      const errMsg = errorInfo|| "Failed to create crop";
      toast.error(errMsg);
      if (onClose) onClose();
    }
  }, [successData, error, errorInfo, onClose, dispatch]);

  useEffect(() => {
    if (updateSuccess) {
      const message = updateSuccess?.message || "Crop updated successfully";
      toast.success(message);
      dispatch(getAllCropsAction());
      if (onRefresh) onRefresh();
      if (onClose) onClose();
    }

    if (updateError) {
      const errMsg = updateErrorInfo|| "Failed to update crop";
      toast.error(errMsg);
      if (onClose) onClose();
    }
    return () => {
      dispatch(clearUpdateCropAction());
    };
  }, [updateSuccess, updateError, updateErrorInfo, onClose, dispatch]);

  return (
    <Box
      sx={{

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 3,

          mt: { xs: 0, sm: 6, md: 0 },
        }}
      >
        {/* Header */}
        <Box display="flex" justifyContent="space-between" mb={3}>
          <Typography variant="h5" fontWeight={600}>
            Crop Information
          </Typography>

          <IconButton size="small" onClick={onClose} sx={{ ml: 3 }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Crop Name */}
        <Box mb={5}>
          <Typography fontSize={14} mb={1}>
            Crop name
          </Typography>
          <TextField
            fullWidth
            placeholder="Crop name"
            value={cropName}
            onChange={(e) => setCropName(e.target.value)}
          />
        </Box>

        {/* Actions */}
        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button

            variant="outlined"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              py: 1.3,
            }}
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button

            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              py: 1.3,
              background: "#4F46E5",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

CropInformation.propTypes = {
  onClose: PropTypes.func.isRequired,
  cropId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRefresh: PropTypes.func,
};

